import EventEmitter from 'owa-event-emitter';

export const mailEventEmitter = new EventEmitter();
export const MAIL_MODULE_SWITCHER_ICON_CLICKED = 'mailModuleSwitcherIconClicked';
